<template>
  <div class="flex flex-col w-full h-full gap-2 overflow-y-auto">
    <span class="text-sm text-surface-500">
      ההודעה תישלח ב-SMS ל{{ customerName }}. מספר הטלפון אינו מוצג לך, אך ההודעה תגיע אליו/ה.
    </span>

    <Textarea
      v-model="message"
      rows="5"
      autoResize
      class="mt-2"
      :maxlength="CUSTOMER_MESSAGE_MAX_LENGTH"
      placeholder="מה תרצו לכתוב?" />
    <small class="text-surface-400">{{ message.length }}/{{ CUSTOMER_MESSAGE_MAX_LENGTH }}</small>

    <drawer-footer
      class="mt-auto"
      approve-label="שליחה"
      :approveDisable="!message.trim()"
      :approveLoading="loading"
      @approve-click="send"
      @cancel-click="$emit('close')"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { CUSTOMER_MESSAGE_MAX_LENGTH } from '@torim-app/types';
import { useToast } from 'vue-toastification';
import { useDrawer } from '@torim-app/shared-components';
import { CustomersApi } from '@app/api/admin';
import { trackEvent } from '@app/composables/posthog';

const props = defineProps<{
  customerId: string;
  customerName: string;
}>();

const emit = defineEmits(['sent', 'close']);

const toast = useToast();
const { closeDrawer } = useDrawer();

const message = ref('');
const loading = ref(false);

const send = async () => {
  if (loading.value || !message.value.trim()) return;
  trackEvent('customer_message_sent');
  loading.value = true;
  try {
    const res = await CustomersApi.sendMessageToCustomer(props.customerId, message.value.trim());
    if (res.optedOut) {
      toast.info('הלקוח/ה ביקש/ה לא לקבל הודעות — ההודעה לא נשלחה');
      return;
    }
    toast.success('ההודעה נשלחה');
    emit('sent');
    closeDrawer();
  } catch (e) {
    console.error(e);
    toast.error('לא הצלחנו לשלוח את ההודעה');
  } finally {
    loading.value = false;
  }
};
</script>
